import { HYDRATE } from 'next-redux-wrapper';

import { ActionTypeEnum } from 'redux/ActionTypeEnum';

const initialState = {
	provincesList: {},
	citiesList: [],
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case HYDRATE: {
			return { ...state, ...action.payload['provinces'] };
		}

		case ActionTypeEnum.province_success: {
			return {
				...state,
				provincesList: action.payload,
			};
		}

		case ActionTypeEnum.filtered_cities_action: {
			const result = (state.provincesList?.ProvinceAndCityList || []).filter((province) =>
				action.payload?.includes(String(province.ID)),
			);

			const modifyProvinces = result.map((city) => city.CityItemsList);

			return { ...state, citiesList: modifyProvinces.flat() }; //modifyProvinces.flat()
		}
		default:
			return state;
	}
};

export { reducer as provinces };
export * from './selectors';
